/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicTournamentRosterPlayer } from './PublicTournamentRosterPlayer';
import {
    PublicTournamentRosterPlayerFromJSON,
    PublicTournamentRosterPlayerFromJSONTyped,
    PublicTournamentRosterPlayerToJSON,
    PublicTournamentRosterPlayerToJSONTyped,
} from './PublicTournamentRosterPlayer';

/**
 * 
 * @export
 * @interface PublicTournamentTeamRoster
 */
export interface PublicTournamentTeamRoster {
    /**
     * 
     * @type {string}
     * @memberof PublicTournamentTeamRoster
     */
    teamId: string;
    /**
     * 
     * @type {Array<PublicTournamentRosterPlayer>}
     * @memberof PublicTournamentTeamRoster
     */
    players: Array<PublicTournamentRosterPlayer>;
}

/**
 * Check if a given object implements the PublicTournamentTeamRoster interface.
 */
export function instanceOfPublicTournamentTeamRoster(value: object): value is PublicTournamentTeamRoster {
    if (!('teamId' in value) || value['teamId'] === undefined) return false;
    if (!('players' in value) || value['players'] === undefined) return false;
    return true;
}

export function PublicTournamentTeamRosterFromJSON(json: any): PublicTournamentTeamRoster {
    return PublicTournamentTeamRosterFromJSONTyped(json, false);
}

export function PublicTournamentTeamRosterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicTournamentTeamRoster {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'],
        'players': ((json['players'] as Array<any>).map(PublicTournamentRosterPlayerFromJSON)),
    };
}

export function PublicTournamentTeamRosterToJSON(json: any): PublicTournamentTeamRoster {
    return PublicTournamentTeamRosterToJSONTyped(json, false);
}

export function PublicTournamentTeamRosterToJSONTyped(value?: PublicTournamentTeamRoster | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
        'players': ((value['players'] as Array<any>).map(PublicTournamentRosterPlayerToJSON)),
    };
}

